export const authLanguageContent = {
    'welcome': {
        'en': 'Welcome',
        'ar': 'مرحبًا',
        'ht': 'Byenveni',
        'pl': 'Witamy',
        'pt': 'Bem-vindo',
        'sr': 'Добро дошли',
        'es': 'Bienvenido',
        'vi': 'Chào mừng',
        'zh': '欢迎',
        'ne': 'स्वागत छ'
    },
    'patient-first-name': {
        'en': 'Patient first name',
        'ar': 'الاسم الأول للمريض',
        'ht': 'Premye non pasyan an',
        'pl': 'Imię pacjenta',
        'pt': 'Nome do paciente',
        'sr': 'Име пацијента',
        'es': 'Nombre del paciente',
        'vi': 'Tên bệnh nhân',
        'zh': '患者名字',
        'ne': 'बिरामीको पहिलो नाम'
    },
    'patient-last-name': {
        'en': 'Patient last name',
        'ar': 'الاسم الأخير للمريض',
        'ht': 'Non pasyan an',
        'pl': 'Nazwisko pacjenta',
        'pt': 'Sobrenome do paciente',
        'sr': 'Презиме пацијента',
        'es': 'apellido del paciente',
        'vi': 'Họ bệnh nhân',
        'zh': '患者姓氏',
        'ne': 'बिरामीको अन्तिम नाम'
    },
    'enter-patient-first-name': {
        'en': 'Enter patient first name',
        'ar': 'أدخل الاسم الأول للمريض',
        'ht': 'Antre premye non pasyan an',
        'pl': 'Wprowadź imię pacjenta',
        'pt': 'Digite o nome do paciente',
        'sr': 'Унесите име пацијента',
        'es': 'Ingrese el nombre del paciente',
        'vi': 'Nhập tên bệnh nhân',
        'zh': '输入患者的名字',
        'ne': 'बिरामीको पहिलो नाम प्रविष्ट गर्नुहोस्'
    },
    'enter-patient-last-name': {
        'en': 'Enter patient last name',
        'ar': 'أدخل الاسم الأخير للمريض',
        'ht': 'Antre dènye non pasyan an',
        'pl': 'Wprowadź nazwisko pacjenta',
        'pt': 'Insira o sobrenome do paciente',
        'sr': 'Унесите презиме пацијента',
        'es': 'Ingrese el apellido del paciente',
        'vi': 'Nhập họ bệnh nhân',
        'zh': '输入患者姓氏',
        'ne': 'बिरामीको अन्तिम नाम प्रविष्ट गर्नुहोस्'
    },
    'patient-dob': {
        'en': 'Patient date of birth',
        'ar': 'تاريخ ميلاد المريض',
        'ht': 'Dat nesans pasyan an',
        'pl': 'Data urodzenia pacjenta',
        'pt': 'Data de nascimento do paciente',
        'sr': 'Датум рођења пацијента',
        'es': 'Fecha de nacimiento del paciente',
        'vi': 'Ngày sinh của bệnh nhân',
        'zh': '患者出生日期',
        'ne': 'बिरामीको जन्म मिति'
    },
    'i-agree': {
        'en': 'I Agree',
        'ar': 'أنا موافق',
        'ht': 'Mwen dakò',
        'pl': 'Zgadzam się',
        'pt': 'Concordo',
        'sr': 'Слажем се',
        'es': 'Estoy de acuerdo',
        'vi': 'Tôi đồng ý',
        'zh': '我同意',
        'ne': 'म सहमत छु'
    },
    'incorrect-first-name-or-last-name': {
        'en': 'Incorrect first name or last name',
        'ar': 'الاسم الأول أو اسم العائلة غير صحيح',
        'ht': 'Non oswa siyati ki pa kòrèk',
        'pl': 'Nieprawidłowe imię lub nazwisko',
        'pt': 'Nome ou sobrenome incorreto',
        'sr': 'Нетачно име или презиме',
        'es': 'Nombre o apellido incorrecto',
        'vi': 'Họ hoặc tên không chính xác',
        'zh': '名字或姓氏不正确',
        'ne': 'गलत पहिलो नाम वा अन्तिम नाम'
    },
    'dob-doesnt-match-with-patient-details': {
        'en': `DOB doesn't match with patient details`,
        'ar': 'تاريخ الميلاد لا يتطابق مع تفاصيل المريض',
        'ht': 'Dat nesans pa matche ak detay pasyan an',
        'pl': 'Data urodzenia nie zgadza się z danymi pacjenta',
        'pt': 'A data de nascimento não corresponde aos dados do paciente',
        'sr': 'Датум рођења се не поклапа са детаљима о пацијенту',
        'es': 'La fecha de nacimiento no coincide con los detalles del paciente.',
        'vi': 'Ngày sinh không khớp với thông tin chi tiết của bệnh nhân',
        'zh': '出生日期与患者详细信息不符',
        'ne': 'जन्म मिति बिरामी विवरणहरूसँग मेल खाँदैन'
    }
}